module.exports = __webpack_public_path__ + "img/icon_xx1.08987e4.png";